<template>
  <div>
    <!-- floating help and about buttons -->
    <v-speed-dial :absolute="!$vuetify.breakpoint.mobile" right>
      <template v-slot:activator>
        <!-- <v-btn
          class="ma-1"
          fab
          @click="toggleHelpText()"
          @mouseover="showTooltip('info')"
          :small="$vuetify.breakpoint.mobile"
          :class="{ buttonStyle: !$vuetify.breakpoint.mobile }"
        >
          <v-icon>
            mdi-information-outline
          </v-icon>
        </v-btn>
        <v-btn
          class="ma-1"
          fab
          @mouseover="showTooltip('question')"
          @click="toggleAboutText()"
          :small="$vuetify.breakpoint.mobile"
        >
          <v-icon>
            mdi-account-question
          </v-icon>
        </v-btn> -->
        
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="toggleHelpText()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-information-outline
              </v-icon>
            </v-btn>
          </template>
          <span>More information</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="toggleAboutText()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-account-question
              </v-icon>
            </v-btn>
          </template>
          <span>About this space</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              fab
              v-bind="attrs"
              v-on="on"
              @click="navigateToProjectPage()"
              :small="$vuetify.breakpoint.mobile"
            >
              <v-icon>
                mdi-exit-to-app
              </v-icon>
            </v-btn>
          </template>
          <span>Back to project page</span>
        </v-tooltip>
      </template>
    </v-speed-dial>

    <!-- HelpText dialog -->
    <v-dialog
      :value="showHelpText"
      :width="$vuetify.breakpoint.mobile ? `90%` : `50%`"
      @click:outside="toggleHelpText()"
      @keydown="toggleHelpText()"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            {{ slideTitle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleHelpText()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-html="helpText" style="padding-top: 2%"> </v-card-text>
      </v-card>
    </v-dialog>

    <!-- About Text dialog -->
    <v-dialog
      :value="showAboutText"
      :width="$vuetify.breakpoint.mobile ? `90%` : `50%`"
      @click:outside="toggleAboutText()"
      @keydown="toggleAboutText()"
    >
      <v-card
        style="min-height: 50vh; max-height: 70vh; overflow-y: auto;"
        class="text-center"
      >
        <v-toolbar dark color="primary">
          <v-toolbar-title>
            About This Space
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="toggleAboutText()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-html="aboutText" style="padding-top: 2%"> </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    slideTitle: { type: String, default: "" },
    helpText: { type: String, default: "" },
    aboutText: { type: String, default: "" },
    showHelpText: { type: Boolean, default: true },
    showAboutText: { type: Boolean, default: false },
    toggleHelpText: { type: Function },
    toggleAboutText: { type: Function }
  },
  methods: {
    navigateToProjectPage() {
      window.open('https://0013915-gdot.hub.arcgis.com/', 'a_blank')
    },
    showTooltip(tip) {
      console.log(tip)
    }
  }
};
</script>

<style>
.buttonStyle {
  margin-top: 25%;
}
</style>
